module.exports = __webpack_public_path__ + "static/media/404.23cfa5d9.png";